"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var React = _interopRequireWildcard(require("react"));
var _utils = require("../utils");
var CommonValues = _interopRequireWildcard(require("../utils/common-values"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */

class MTableEditRow extends React.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "handleSave", () => {
      const newData = this.state.data;
      delete newData.tableData;
      this.props.onEditingApproved(this.props.mode, this.state.data, this.props.data);
    });
    (0, _defineProperty2.default)(this, "handleKeyDown", e => {
      if (e.keyCode === 13 && e.target.type !== "textarea") {
        this.handleSave();
      } else if (e.keyCode === 13 && e.target.type === "textarea" && e.shiftKey) {
        this.handleSave();
      } else if (e.keyCode === 27) {
        this.props.onEditingCanceled(this.props.mode, this.props.data);
      }
    });
    this.state = {
      data: props.data ? JSON.parse(JSON.stringify(props.data)) : this.createRowData()
    };
  }
  createRowData() {
    return this.props.columns.filter(column => "initialEditValue" in column && column.field).reduce((prev, column) => {
      prev[column.field] = column.initialEditValue;
      return prev;
    }, {});
  }
  renderColumns() {
    const size = CommonValues.elementSize(this.props);
    const mapArr = this.props.columns.filter(columnDef => !columnDef.hidden && !(columnDef.tableData.groupOrder > -1)).sort((a, b) => a.tableData.columnOrder - b.tableData.columnOrder).map((columnDef, index) => {
      const value = typeof this.state.data[columnDef.field] !== "undefined" ? this.state.data[columnDef.field] : (0, _utils.byString)(this.state.data, columnDef.field);
      const getCellStyle = (columnDef, value) => {
        let cellStyle = {
          color: "inherit"
        };
        if (typeof columnDef.cellStyle === "function") {
          cellStyle = (0, _objectSpread2.default)({}, cellStyle, columnDef.cellStyle(value, this.props.data));
        } else {
          cellStyle = (0, _objectSpread2.default)({}, cellStyle, columnDef.cellStyle);
        }
        if (columnDef.disableClick) {
          cellStyle.cursor = "default";
        }
        return (0, _objectSpread2.default)({}, cellStyle);
      };
      const style = {};
      if (index === 0) {
        style.paddingLeft = 24 + this.props.level * 20;
      }
      let allowEditing = false;
      if (columnDef.editable === undefined) {
        allowEditing = true;
      }
      if (columnDef.editable === "always") {
        allowEditing = true;
      }
      if (columnDef.editable === "onAdd" && this.props.mode === "add") {
        allowEditing = true;
      }
      if (columnDef.editable === "onUpdate" && this.props.mode === "update") {
        allowEditing = true;
      }
      if (typeof columnDef.editable === "function") {
        allowEditing = columnDef.editable(columnDef, this.props.data);
      }
      if (!columnDef.field || !allowEditing) {
        const readonlyValue = this.props.getFieldValue(this.state.data, columnDef);
        return /*#__PURE__*/React.createElement(this.props.components.Cell, {
          size: size,
          icons: this.props.icons,
          columnDef: columnDef,
          value: readonlyValue,
          key: columnDef.tableData.id,
          rowData: this.props.data,
          style: getCellStyle(columnDef, value)
        });
      } else {
        const {
            editComponent
          } = columnDef,
          cellProps = (0, _objectWithoutProperties2.default)(columnDef, ["editComponent"]);
        const EditComponent = editComponent || this.props.components.EditField;
        let error = {
          isValid: true,
          helperText: ""
        };
        if (columnDef.validate) {
          const validateResponse = columnDef.validate(this.state.data);
          switch (typeof validateResponse) {
            case "object":
              error = (0, _objectSpread2.default)({}, validateResponse);
              break;
            case "boolean":
              error = {
                isValid: validateResponse,
                helperText: ""
              };
              break;
            case "string":
              error = {
                isValid: false,
                helperText: validateResponse
              };
              break;
          }
        }
        return /*#__PURE__*/React.createElement(_TableCell.default, {
          size: size,
          key: columnDef.tableData.id,
          align: ["numeric"].indexOf(columnDef.type) !== -1 ? "right" : "left",
          style: getCellStyle(columnDef, value)
        }, /*#__PURE__*/React.createElement(EditComponent, {
          key: columnDef.tableData.id,
          columnDef: cellProps,
          value: value,
          error: !error.isValid,
          helperText: error.helperText,
          locale: this.props.localization.dateTimePickerLocalization,
          rowData: this.state.data,
          onChange: value => {
            const data = (0, _objectSpread2.default)({}, this.state.data);
            (0, _utils.setByString)(data, columnDef.field, value);
            // data[columnDef.field] = value;
            this.setState({
              data
            }, () => {
              if (this.props.onBulkEditRowChanged) {
                this.props.onBulkEditRowChanged(this.props.data, data);
              }
            });
          },
          onRowDataChange: data => {
            this.setState({
              data
            }, () => {
              if (this.props.onBulkEditRowChanged) {
                this.props.onBulkEditRowChanged(this.props.data, data);
              }
            });
          }
        }));
      }
    });
    return mapArr;
  }
  renderActions() {
    if (this.props.mode === "bulk") {
      return /*#__PURE__*/React.createElement(_TableCell.default, {
        padding: "none",
        key: "key-actions-column"
      });
    }
    const size = CommonValues.elementSize(this.props);
    const localization = (0, _objectSpread2.default)({}, MTableEditRow.defaultProps.localization, this.props.localization);
    const isValid = this.props.columns.every(column => {
      if (column.validate) {
        const response = column.validate(this.state.data);
        switch (typeof response) {
          case "object":
            return response.isValid;
          case "string":
            return response.length === 0;
          case "boolean":
            return response;
        }
      } else {
        return true;
      }
    });
    const actions = [{
      icon: this.props.icons.Check,
      tooltip: localization.saveTooltip,
      disabled: !isValid,
      onClick: this.handleSave
    }, {
      icon: this.props.icons.Clear,
      tooltip: localization.cancelTooltip,
      onClick: () => {
        this.props.onEditingCanceled(this.props.mode, this.props.data);
      }
    }];
    return /*#__PURE__*/React.createElement(_TableCell.default, {
      size: size,
      padding: "none",
      key: "key-actions-column",
      style: (0, _objectSpread2.default)({
        width: 42 * actions.length,
        padding: "0px 5px"
      }, this.props.options.editCellStyle)
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React.createElement(this.props.components.Actions, {
      data: this.props.data,
      actions: actions,
      components: this.props.components,
      size: size
    })));
  }
  getStyle() {
    const style = {
      // boxShadow: '1px 1px 1px 1px rgba(0,0,0,0.2)',
      borderBottom: "1px solid red"
    };
    return style;
  }
  render() {
    const size = CommonValues.elementSize(this.props);
    const localization = (0, _objectSpread2.default)({}, MTableEditRow.defaultProps.localization, this.props.localization);
    let columns;
    if (this.props.mode === "add" || this.props.mode === "update" || this.props.mode === "bulk") {
      columns = this.renderColumns();
    } else {
      const colSpan = this.props.columns.filter(columnDef => !columnDef.hidden && !(columnDef.tableData.groupOrder > -1)).length;
      columns = [/*#__PURE__*/React.createElement(_TableCell.default, {
        size: size,
        padding: this.props.options.actionsColumnIndex === 0 ? "none" : undefined,
        key: "key-edit-cell",
        colSpan: colSpan
      }, /*#__PURE__*/React.createElement(_Typography.default, {
        variant: "h6"
      }, localization.deleteText))];
    }
    if (this.props.options.selection) {
      columns.splice(0, 0, /*#__PURE__*/React.createElement(_TableCell.default, {
        padding: "none",
        key: "key-selection-cell"
      }));
    }
    if (this.props.isTreeData) {
      columns.splice(0, 0, /*#__PURE__*/React.createElement(_TableCell.default, {
        padding: "none",
        key: "key-tree-data-cell"
      }));
    }
    if (this.props.options.actionsColumnIndex === -1) {
      columns.push(this.renderActions());
    } else if (this.props.options.actionsColumnIndex >= 0) {
      let endPos = 0;
      if (this.props.options.selection) {
        endPos = 1;
      }
      if (this.props.isTreeData) {
        endPos = 1;
        if (this.props.options.selection) {
          columns.splice(1, 1);
        }
      }
      columns.splice(this.props.options.actionsColumnIndex + endPos, 0, this.renderActions());
    }

    // Lastly we add detail panel icon
    if (this.props.detailPanel) {
      const aligment = this.props.options.detailPanelColumnAlignment;
      const index = aligment === "left" ? 0 : columns.length;
      columns.splice(index, 0, /*#__PURE__*/React.createElement(_TableCell.default, {
        padding: "none",
        key: "key-detail-panel-cell"
      }));
    }
    this.props.columns.filter(columnDef => columnDef.tableData.groupOrder > -1).forEach(columnDef => {
      columns.splice(0, 0, /*#__PURE__*/React.createElement(_TableCell.default, {
        padding: "none",
        key: "key-group-cell" + columnDef.tableData.id
      }));
    });
    const _this$props = this.props,
      {
        detailPanel,
        isTreeData,
        onRowClick,
        onRowSelected,
        onTreeExpandChanged,
        onToggleDetailPanel,
        onEditingApproved,
        onEditingCanceled,
        getFieldValue,
        components,
        icons,
        columns: columnsProp,
        // renamed to not conflict with definition above
        localization: localizationProp,
        // renamed to not conflict with definition above
        options,
        actions,
        errorState,
        onBulkEditRowChanged,
        scrollWidth
      } = _this$props,
      rowProps = (0, _objectWithoutProperties2.default)(_this$props, ["detailPanel", "isTreeData", "onRowClick", "onRowSelected", "onTreeExpandChanged", "onToggleDetailPanel", "onEditingApproved", "onEditingCanceled", "getFieldValue", "components", "icons", "columns", "localization", "options", "actions", "errorState", "onBulkEditRowChanged", "scrollWidth"]);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_TableRow.default, (0, _extends2.default)({
      onKeyDown: this.handleKeyDown
    }, rowProps, {
      style: this.getStyle()
    }), columns));
  }
}
exports.default = MTableEditRow;
MTableEditRow.defaultProps = {
  actions: [],
  index: 0,
  options: {},
  path: [],
  localization: {
    saveTooltip: "Save",
    cancelTooltip: "Cancel",
    deleteText: "Are you sure you want to delete this row?"
  },
  onBulkEditRowChanged: () => {}
};
MTableEditRow.propTypes = {
  actions: _propTypes.default.array,
  icons: _propTypes.default.any.isRequired,
  index: _propTypes.default.number.isRequired,
  data: _propTypes.default.object,
  detailPanel: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]))]),
  options: _propTypes.default.object.isRequired,
  onRowSelected: _propTypes.default.func,
  path: _propTypes.default.arrayOf(_propTypes.default.number),
  columns: _propTypes.default.array,
  onRowClick: _propTypes.default.func,
  onEditingApproved: _propTypes.default.func,
  onEditingCanceled: _propTypes.default.func,
  localization: _propTypes.default.object,
  getFieldValue: _propTypes.default.func,
  errorState: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.bool]),
  onBulkEditRowChanged: _propTypes.default.func
};